module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Cadastro de Contrato")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "pull-right hidden-print",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'config.contratos.list'
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$route.params.id && 'Atualizado' || 'Cadastrado') + " com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nome),
      expression: "data.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Conta Bancária")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [(!_vm.contasBancarias) ? _c('span', [_vm._v("Carregando...")]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.contaBancaria),
      expression: "data.contaBancaria"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "contaBancaria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.contasBancarias), function(conta) {
    return _c('option', {
      key: conta.id,
      domProps: {
        "value": conta.id
      }
    }, [_vm._v(_vm._s(conta.nomeBanco))])
  })], 2), _vm._v(" "), _c('div', [_c('u-button', {
    staticClass: "btn btn-default btn-xs m-t-xs",
    on: {
      "click": function($event) {
        _vm.showCadastroContaBancaria = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cadastrar nova conta bancária\n                  ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "cobrar-taxa-bancaria"
    }
  }, [_vm._v("Cobrar Taxa Bancária")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cobrarTaxaBancaria),
      expression: "data.cobrarTaxaBancaria"
    }],
    attrs: {
      "type": "checkbox",
      "id": "cobrar-taxa-bancaria"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.cobrarTaxaBancaria) ? _vm._i(_vm.data.cobrarTaxaBancaria, null) > -1 : (_vm.data.cobrarTaxaBancaria)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.cobrarTaxaBancaria,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "cobrarTaxaBancaria", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "cobrarTaxaBancaria", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "cobrarTaxaBancaria", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "desconto-fim-semana"
    }
  }, [_vm._v("Possui Desconto no Fim de Semana")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.descontoFimDeSemana),
      expression: "data.descontoFimDeSemana"
    }],
    attrs: {
      "type": "checkbox",
      "id": "desconto-fim-semana"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.descontoFimDeSemana) ? _vm._i(_vm.data.descontoFimDeSemana, null) > -1 : (_vm.data.descontoFimDeSemana)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.descontoFimDeSemana,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "descontoFimDeSemana", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "descontoFimDeSemana", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "descontoFimDeSemana", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "desconto-feriado"
    }
  }, [_vm._v("Possui Desconto em Feriados")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.descontoFeriado),
      expression: "data.descontoFeriado"
    }],
    attrs: {
      "type": "checkbox",
      "id": "desconto-feriado"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.descontoFeriado) ? _vm._i(_vm.data.descontoFeriado, null) > -1 : (_vm.data.descontoFeriado)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.descontoFeriado,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "descontoFeriado", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "descontoFeriado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "descontoFeriado", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Quantidade máxima de diárias")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.limiteDiarias),
      expression: "data.limiteDiarias"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.data.limiteDiarias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "limiteDiarias", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Valor do Km Fora da Cidade")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.valorKmForaDaCidade),
      expression: "data.valorKmForaDaCidade"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.valorKmForaDaCidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "valorKmForaDaCidade", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "usa-ggv"
    }
  }, [_vm._v("Usa controle de Guia de Guarda Veicular (GGV)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.usaGgv),
      expression: "data.usaGgv"
    }],
    attrs: {
      "id": "usa-ggv",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.usaGgv) ? _vm._i(_vm.data.usaGgv, null) > -1 : (_vm.data.usaGgv)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.usaGgv,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "usaGgv", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "usaGgv", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "usaGgv", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped b-t b-light"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Categoria")]), _vm._v(" "), _c('th', [_vm._v("Valor para Reboque")]), _vm._v(" "), _c('th', [_vm._v("Valor para Diária")]), _vm._v(" "), _c('th', [_vm._v("Valor Km Adicional")]), _vm._v(" "), _c('th', [_vm._v("Valor Hora de Serviço Adicional")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l(([1, 2, 3]), function(i) {
    return (!_vm.data.categoriasContratos) ? _c('tr', [_c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "v-middle"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "20px"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "v-middle"
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "20px"
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('u-fake-loader', {
      staticClass: "m-t",
      attrs: {
        "width": "100%"
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.data.categoriasContratos), function(contratoCategoria, index) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [(!_vm.data.categoriasContratos) ? _c('span', [_vm._v("Carregando...")]) : _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contratoCategoria.bemCategoria),
        expression: "contratoCategoria.bemCategoria"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(contratoCategoria, "bemCategoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.categoriasVeiculares), function(categoria) {
      return _c('option', {
        key: categoria.id,
        domProps: {
          "value": categoria.id
        }
      }, [_vm._v("\n                            " + _vm._s(categoria.nome) + "\n                          ")])
    })], 2)])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contratoCategoria.valorReboque),
        expression: "contratoCategoria.valorReboque"
      }, {
        name: "money",
        rawName: "v-money",
        value: (_vm.money),
        expression: "money"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (contratoCategoria.valorReboque)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contratoCategoria, "valorReboque", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contratoCategoria.valorDiaria),
        expression: "contratoCategoria.valorDiaria"
      }, {
        name: "money",
        rawName: "v-money",
        value: (_vm.money),
        expression: "money"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (contratoCategoria.valorDiaria)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contratoCategoria, "valorDiaria", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contratoCategoria.valorKmAdicional),
        expression: "contratoCategoria.valorKmAdicional"
      }, {
        name: "money",
        rawName: "v-money",
        value: (_vm.money),
        expression: "money"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (contratoCategoria.valorKmAdicional)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contratoCategoria, "valorKmAdicional", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (contratoCategoria.valorHoraServicoAdicional),
        expression: "contratoCategoria.valorHoraServicoAdicional"
      }, {
        name: "money",
        rawName: "v-money",
        value: (_vm.money),
        expression: "money"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (contratoCategoria.valorHoraServicoAdicional)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(contratoCategoria, "valorHoraServicoAdicional", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('td', [_c('u-button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Excluir"
      },
      on: {
        "click": function($event) {
          return _vm.removeValorCategoria(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1)])
  }), _vm._v(" "), (_vm.data.categoriasContratos && _vm.data.categoriasContratos.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Nenhum registro encontrado")])]) : _vm._e()], 2)]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": _vm.addValorCategoria
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar valor de categoria\n              ")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        _vm.showCadastroCategoriaVeicular = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cadastrar nova categoria veicular\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    on: {
      "click": _vm.submit
    }
  }, [(!_vm.data.id) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'config.contratos.list'
        })
      }
    }
  }, [_vm._v("Cancelar")])], 1)])])])]), _vm._v(" "), (_vm.showCadastroContaBancaria) ? _c('popup-viewer', {
    attrs: {
      "title": "Cadastro de conta bancária"
    },
    on: {
      "close": _vm.closeCadastroContaBancaria
    }
  }, [_c('CadastroContaBancaria', {
    attrs: {
      "viewer-mode": ""
    },
    on: {
      "finishSubmit": _vm.closeCadastroContaBancaria,
      "cancel": function($event) {
        _vm.showCadastroContaBancaria = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showCadastroCategoriaVeicular) ? _c('popup-viewer', {
    attrs: {
      "title": "Cadastro de categoria veicular"
    },
    on: {
      "close": _vm.closeCadastroCategoriaVeicular
    }
  }, [_c('CadastroCategoriaVeicular', {
    attrs: {
      "viewer-mode": ""
    },
    on: {
      "finishSubmit": _vm.closeCadastroCategoriaVeicular,
      "cancel": function($event) {
        _vm.showCadastroCategoriaVeicular = false
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-566820bc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/configuracoes/contratos/components/NovoContrato.vue
// module id = 1870
// module chunks = 18